// extracted by mini-css-extract-plugin
module.exports = {"container":"PolicyEmpty_container__hD8VB","text":"PolicyEmpty_text___shKY"};